<mat-card>
    <mat-card-header>    
        <mat-card-title class="popupHeader">
          <div class="mat-card-header-text" i18n>
            Advanced Cache Settings
          </div>       
        </mat-card-title>            
        <button mat-icon-button i18n-matTooltip matTooltip="Choose criteria" [matMenuTriggerFor]="menu" [disabled]="!chosenRegion">
          <mat-icon>category</mat-icon>
        </button>     
        <mat-menu #menu="matMenu">
            <button mat-menu-item *ngFor="let option of allOptions" (click) = selectCriteria(option)>{{option}}</button>
          </mat-menu>
    </mat-card-header>
  
    <mat-card-content>
      <div class="mainCard">
        <mat-card class="listView">
            <p class="listHeader" i18n>Select a region:</p> 
            <div class="listViewCard column">
                <mat-list>                
                    <mat-list-item *ngFor="let reg of regions" [value]="reg" [class.selected]="chosenRegion === reg" (click)="selectRegion(reg)">
                        <button class="leftIcon" mat-icon-button [style.visibility]="chosenRegion === reg ? 'visible':'hidden'">
                            <mat-icon class="iconTyp">task_alt</mat-icon>
                        </button>
                        <div matListItemTitle class="regItem">{{reg.name}}</div>
                    </mat-list-item>
                </mat-list>
            </div>
        </mat-card>

        <div class="separator"></div>
        
        <mat-card class="listView">
            <p class="listHeader" *ngIf="isSelectionEnabled">{{criteriaHeader}}</p> 
            <div class="listViewCard">
                <mat-selection-list *ngIf="isSelectionEnabled" [(ngModel)]="selectedOwners" class="itemsList">
                    <mat-list-option *ngFor="let customer of customers" [value]="customer">
                        <div matListItemTitle class="listItem">{{customer.code}} - {{customer.name}}</div>
                    </mat-list-option>               
                </mat-selection-list>
            </div>
        </mat-card>        
      </div>
    </mat-card-content>
  
    <mat-card-actions>
      <div class="buttonContent">      
        <button mat-raised-button i18n type="button" color="primary" (click)="onSave()">SAVE</button>
      </div>    
    </mat-card-actions>
  </mat-card>  